export default __webpack_public_path__ + "static/media/29.4290a808.png";